import React from "react";

const Boxing = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      className={className}
    >
      <g clip-path="url(#clip0_14545_80143)">
        <path d="M23.4643 9.59999L21.8192 7.95053C21.685 0.776711 15.3054 0 12.5464 0H11.4555C8.69664 0 2.31701 0.776711 2.18283 7.95053L0.537722 9.59999C0.179154 9.95626 0.00661951 10.459 0.0707957 10.9604L0.989359 18.3076C1.0634 18.9395 1.50241 19.4687 2.10971 19.6582C2.56569 19.7957 3.47224 20.3586 4.40609 22.5753C4.6697 23.382 5.39844 23.9464 6.24536 24C7.71589 23.9935 9.24646 22.2 9.94027 20.5145C10.6341 18.8291 10.5272 17.3825 9.65989 16.5153C8.78331 15.7128 7.69876 15.173 6.53009 14.9574C5.13371 14.5974 4.36462 14.4 4.36462 12.5454C4.35567 12.0181 4.57765 11.5132 4.97227 11.1633C6.72098 9.52257 11.3737 9.80944 11.4555 9.81819H12.5824C13.8828 9.7309 17.5744 9.8029 19.0286 11.1633C19.4235 11.5131 19.6459 12.018 19.6374 12.5454C19.6374 14.4 18.8683 14.6007 17.473 14.9662C16.3043 15.1817 15.2197 15.7215 14.3432 16.524C13.4759 17.3913 13.3734 18.8487 14.0628 20.5233C14.7523 22.1979 16.2872 24 17.7567 24H17.7643C18.6196 23.9684 19.3579 23.3912 19.5948 22.5687C20.5298 20.3509 21.4352 19.7891 21.8912 19.6517C22.4986 19.4622 22.9375 18.933 23.0116 18.3011L23.9301 10.9538C23.9927 10.4548 23.8206 9.95493 23.4643 9.59999Z" />
      </g>
    </svg>
  );
};

export default Boxing;
